



































































































































































import { Component, Vue, Watch, Prop} from 'vue-property-decorator';
import PositionsVue from '@/components/Agencies/Positions.vue';
import PositionDto from '@/models/Positions/PositionDto'
import DateTimeUtils from '@/lib/dateTimeUtils';
import BookingRoleDto from '@/models/BookingRoles/BookingRoleDto';
import { BookingDetailsModule } from '@/store/modules/bookingDetails';
import WorkerDto from '@/models/Workers/WorkerDto';
import BookingManageWorkersRetractOffer from '@/components/BookingRoleWorkers/BookingManageWorkersRetractOffer.vue';
import BookingManageWorkersApplyDecline from '@/components/BookingRoleWorkers/BookingManageWorkersApplyDecline.vue';
import BookingManageWorkersBook from '@/components/BookingRoleWorkers/BookingManageWorkersBook.vue';
import BookingManageWorkersResendConfirmation from '@/components/BookingRoleWorkers/BookingManageWorkersResendConfirmation.vue';
import BookingManageWorkersReject from '@/components/BookingRoleWorkers/BookingManageWorkersReject.vue';
import BookingManageWorkersAddShifts from '@/components/BookingRoleWorkers/BookingManageWorkersAddShifts.vue';
import BookingRoleWorkerDto from '@/models/BookingRoleWorkers/BookingRoleWorkerDto';
import GiganautVue from '@/components/Shared/GiganautVue';
import WorkerAvailability from '@/components/Workers/WorkerTempDetails.vue';
import BookingRoleWorkerStatus from '@/components/BookingRoleWorkers/Display/BookingRoleWorkerStatus.vue'
import BookingRoleWorkerShiftStatus from '@/components/BookingRoleWorkerShifts/Display/BookingRoleWorkerShiftStatus.vue'
import WorkerProfileTempSummary from '@/components/Workers/WorkerProfileTempSummary.vue';
import BookingRoleWorkerShiftStatusEnum from '@/models/BookingRoleWorkerShifts/BookingRoleWorkerShiftStatus';
import BookingRoleWorkerShiftCancel from '@/components/BookingRoleWorkerShifts/BookingRoleWorkerShiftCancel.vue';
import BookingOfferShiftReply from '@/models/BookingRoleWorkerShifts/BookingOfferShiftReply';
import BookingRoleWorkerShiftDto from '@/models/BookingRoleWorkerShifts/BookingRoleWorkerShiftDto';
import { VuetifyConfirmObject } from 'vuetify-confirm';
import ShiftStatus from '@/components/Shifts/Display/ShiftStatus.vue';
import GiganautAppIcon from '@/components/Apps/Display/GiganautAppIcon.vue';
import BookingRoleWorkerConversation from '@/components/Conversations/BookingRoleWorkerConversation.vue'
import MessageBody from '@/components/Messages/Display/MessageBody.vue';
import Alert from '../Shared/Alert.vue';
import { AppModule } from '@/store/modules/app';

@Component({
  name: 'BookingManageWorkers',
  components: { ShiftStatus, MessageBody, BookingRoleWorkerConversation, BookingManageWorkersRetractOffer, BookingManageWorkersApplyDecline, BookingManageWorkersAddShifts, BookingManageWorkersReject, BookingManageWorkersBook, BookingManageWorkersResendConfirmation, WorkerAvailability, BookingRoleWorkerStatus, BookingRoleWorkerShiftStatus, WorkerProfileTempSummary, BookingRoleWorkerShiftCancel, GiganautAppIcon, Alert } 
})
export default class extends GiganautVue {

	page = 1;
	perPage = 8;

	bookingRoleWorkerShiftStatusEnum = BookingRoleWorkerShiftStatusEnum;

	@Prop()
	selectedBookingRole: BookingRoleDto;

	get currentBooking() {
		return BookingDetailsModule.currentBooking;
	}

    getWorkerUrl(workerId: string) {
		//console.log(location);
		return location.origin + "/agency/workers/" + workerId;
	}

	getWorkerAvatarUrl(worker: WorkerDto) {
		return AppModule.currentAgencyContext.storageSharedBaseUrl + "/avatars/3/" + worker.id + "/resized-100/" + worker.avatar;
	}

	async showCancel(status: BookingRoleWorkerShiftStatusEnum) {
		return false;
		if (status === BookingRoleWorkerShiftStatusEnum.BookedUnconfirmed || 
		status === BookingRoleWorkerShiftStatusEnum.BookedConfirmed) {
			return false;
		}
		return true;
	}

	@Watch('selectedBookingRole', { immediate: true })
    async onSelectedBookingRoleChanged(val: BookingRoleDto, oldVal: BookingRoleDto) {
		await BookingDetailsModule.updateOfferedSelectedBookingRole(val);
		await BookingDetailsModule.getConversations(1);
	}

	get selectedBookingRoleWorkerShifts() {
		return BookingDetailsModule.offeredWorkersVM.selectedBookingRoleWorker.bookingRoleWorkerShifts;
	}

	get selectedBookingRoleWorker() {
		return BookingDetailsModule.offeredWorkersVM.selectedBookingRoleWorker;
	}

	set selectedBookingRoleWorker(value: BookingRoleWorkerDto) {
		BookingDetailsModule.offeredWorkersVM.selectedWorkerId = value.workerId;
		BookingDetailsModule.offeredWorkersVM.selectedBookingRoleWorker = value;
	}

	get selectedWorker() {
		return BookingDetailsModule.offeredWorkersVM.selectedWorker;
	}

	get shiftCount() {
		return BookingDetailsModule.offeredWorkersVM.selectedBookingRole.shifts.length;
	}

	get bookingRoleWorkers() {
		return BookingDetailsModule.offeredWorkersVM.bookingRoleWorkers;
	}

	get pagedBookingRoleWorkers() {
		return this.bookingRoleWorkers.slice((this.page - 1)* this.perPage, this.page* this.perPage)
	}

	get messages() {
		return BookingDetailsModule.messages;
	}


	@Watch('selectedBookingRoleWorker', { immediate: true })
    async onSelectedBookingRoleWorkerChanged(val: BookingRoleWorkerDto, oldVal: BookingRoleWorkerDto) {
	  if (val.id != null) {
		   //Update the selected booking role worker

		   //Fetch the workers details
		   await BookingDetailsModule.getOfferedWorker(val.workerId);
		 	//Fetch the   
		   await BookingDetailsModule.updateConversation(val);
	   }
	}

	async onPageChanged(input: number){
		BookingDetailsModule.offeredWorkersVM.selectedBookingRoleWorker = (this.pagedBookingRoleWorkers[0]);
	}

	 async deleteBookingRoleWorkerShift(bookingRoleWorkerShift: BookingRoleWorkerShiftDto){
        const options: VuetifyConfirmObject = {
            buttonTrueText: "DELETE",
            buttonFalseText: "CANCEL",
            buttonTrueColor: "primary",
            buttonFalseColor: "primary",
        }
        const result = await this.$confirm('Are you sure you want to remove this ' + this.Labels.worker.toLowerCase() + ' from the shortlist?', options);
        if (result) {
            await BookingDetailsModule.deleteBookingRoleWorkerShift(bookingRoleWorkerShift);
        }
    } 
	  
  	availabilityClass(isAvailable: boolean){
	  if (isAvailable) {
		  return "available";
	  } 
	  else {
		  return "unavailable";
	  }
  }
}
